import React from 'react';
import { FC } from 'react';
import './styles.css';
import { TRectangleDownProps } from './types';

export const RectangleDown: FC<TRectangleDownProps> = ({ color }) => (
	<span className="chart-rectangle-down--container">
		<span className="chart-rectangle-down" style={{ borderTop: `10px solid ${color}` }} />
	</span>
);
